<template>
    <b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true id="popup-upload" @ok="uploadButtonAction" :okTitle="okTitle" title="Upload Data">
        <b-card>
            <b-row>
                <b-col cols="12">
                    <app-input-fileupload label="File" size="sm" :model.sync="fileupload" />
                </b-col>
            </b-row>
            <b-row v-if="isUploadSuccess">
                <b-col cols="12">
					<b-card no-body>
						<b-tabs card>
							                            <b-tab title="Upload Part Purchase Quality Control Confirmation" active>

                                <b-row v-if="hasFailedDataPartPurchaseQualityControlConfirmation">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedPartPurchaseQualityControlConfirmation.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="partPurchaseQualityControlConfirmationsFailed" :fields="fieldsPartPurchaseQualityControlConfirmation" :busy="isDataLoading"
                                                         :sort-by.sync="sortByPartPurchaseQualityControlConfirmation" :sort-desc.sync="sortDescPartPurchaseQualityControlConfirmation" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(partPurchaseQualityControlConfirmationDate)="row">
													{{ row.item.partPurchaseQualityControlConfirmationDate | moment("DD-MMM-YYYY") }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedPartPurchaseQualityControlConfirmation.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="partPurchaseQualityControlConfirmations" :fields="fieldsPartPurchaseQualityControlConfirmation" :busy="isDataLoading"
                                                         :sort-by.sync="sortByPartPurchaseQualityControlConfirmation" :sort-desc.sync="sortDescPartPurchaseQualityControlConfirmation" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(partPurchaseQualityControlConfirmationDate)="row">
													{{ row.item.partPurchaseQualityControlConfirmationDate | moment("DD-MMM-YYYY") }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>                            <b-tab title="Upload Part Purchase Quality Control Confirmation Detail" active>

                                <b-row v-if="hasFailedDataPartPurchaseQualityControlConfirmationDetail">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedPartPurchaseQualityControlConfirmationDetail.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="partPurchaseQualityControlConfirmationDetailsFailed" :fields="fieldsPartPurchaseQualityControlConfirmationDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortByPartPurchaseQualityControlConfirmationDetail" :sort-desc.sync="sortDescPartPurchaseQualityControlConfirmationDetail" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(qty)="row">
													{{ Number(row.item.qty).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedPartPurchaseQualityControlConfirmationDetail.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="partPurchaseQualityControlConfirmationDetails" :fields="fieldsPartPurchaseQualityControlConfirmationDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortByPartPurchaseQualityControlConfirmationDetail" :sort-desc.sync="sortDescPartPurchaseQualityControlConfirmationDetail" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(qty)="row">
													{{ Number(row.item.qty).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>

						</b-tabs>
					</b-card>
                </b-col>
            </b-row>
        </b-card>
        <template #modal-footer="{ ok, cancel }">
            <b-button v-if="isUploadSuccess" size="sm" variant="primary" @click="downloadLog()">
                Download Log
            </b-button>
            <b-button size="sm" variant="success" class="float-right" @click="ok()">
                {{ okTitle }}
            </b-button>
            <b-button size="sm" variant="secondary" class="float-right" @click="cancel()">
                Cancel
            </b-button>
        </template>
        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </b-modal>
</template>
<style lang="scss" scoped>
    .card {
        border: 1px solid rgba(0, 0, 0, 0.125) !important;
    }

    ::v-deep.th-message {
        color: red;
    }

    ::v-deep.modal-footer {
        display: block;
    }
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { saveAs } from 'file-saver';

import PartPurchaseQualityControlConfirmation from '@/models/PartPurchaseQualityControlConfirmation/PartPurchaseQualityControlConfirmation';
import PartPurchaseQualityControlConfirmationList from '@/models/PartPurchaseQualityControlConfirmation/PartPurchaseQualityControlConfirmationList';
import PartPurchaseQualityControlConfirmationFilter from '@/filters/PartPurchaseQualityControlConfirmation/PartPurchaseQualityControlConfirmationFilter';

import AppInputFileupload from '@/components/AppInputFileupload';

export default {
	props: ['model', 'openPopup','uploadButtonMethod', 'parentId'],
	components : {AppInputFileupload,},
	data() {
		return {
			fileupload: null,
			uploadProcessId: null,
			datas: Array(),
			fieldsPartPurchaseQualityControlConfirmation: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Part Purchase Quality Control", key: 'partPurchaseQualityControlPartPurchaseQualityControlDate', sortable: false},
				{"class" : "th-status", "label" : "Part Purchase Quality Control Date", key: 'partPurchaseQualityControlConfirmationDate', sortable: false},
				{"class" : "th-status", "label" : "Revisi", key: 'revisi', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],
			fieldsPartPurchaseQualityControlConfirmationDetail: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Control Card", key: 'controlCardControlCardNumber', sortable: false},
				{"class" : "th-status", "label" : "Thickness", key: 'thickness', sortable: false},
				{"class" : "th-status", "label" : "Width", key: 'width', sortable: false},
				{"class" : "th-status", "label" : "Length", key: 'length', sortable: false},
				{"class" : "th-status", "label" : "Qty", key: 'qty', sortable: false},
				{"class" : "th-status", "label" : "Karat", key: 'karat', sortable: false},
				{"class" : "th-status", "label" : "Retak", key: 'retak', sortable: false},
				{"class" : "th-status", "label" : "Goresan", key: 'goresan', sortable: false},
				{"class" : "th-status", "label" : "Gelombang", key: 'gelombang', sortable: false},
				{"class" : "th-status", "label" : "Burry", key: 'burry', sortable: false},
				{"class" : "th-status", "label" : "Benjolan", key: 'benjolan', sortable: false},
				{"class" : "th-status", "label" : "Other Problem", key: 'otherProblem', sortable: false},
				{"class" : "th-status", "label" : "Ng Information", key: 'ngInformation', sortable: false},
				{"class" : "th-status", "label" : "Control Card Status", key: 'controlCardStatusName', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],

			busy:false,
			isDataLoading: false,
			isBusy : false,
			partPurchaseQualityControlConfirmations : [],
			partPurchaseQualityControlConfirmationsFailed: [],
			partPurchaseQualityControlConfirmationId : '',
			sortByPartPurchaseQualityControlConfirmation: '',
			sortDescPartPurchaseQualityControlConfirmation: '',
			hasFailedDataPartPurchaseQualityControlConfirmation: false,
			totalFailedPartPurchaseQualityControlConfirmation: 0,
			totalSucceedPartPurchaseQualityControlConfirmation: 0,
			partPurchaseQualityControlConfirmationDetails : [],
			partPurchaseQualityControlConfirmationDetailsFailed: [],
			partPurchaseQualityControlConfirmationDetailId : '',
			sortByPartPurchaseQualityControlConfirmationDetail: '',
			sortDescPartPurchaseQualityControlConfirmationDetail: '',
			hasFailedDataPartPurchaseQualityControlConfirmationDetail: false,
			totalFailedPartPurchaseQualityControlConfirmationDetail: 0,
			totalSucceedPartPurchaseQualityControlConfirmationDetail: 0,


			processId: '',
			isUploadSuccess: false,
		}
	},
	methods : {
		resetModal() {
			this.datas = Array();
			this.isUploadSuccess = false;
			this.$emit('resetMethod');
		},
		uploadButtonAction(modalEvent) {
			modalEvent.preventDefault();
			this.isBusy = true;
			if (this.isUploadSuccess) {
				let _this = this;
				this.$http.post('partpurchasequalitycontrolconfirmation/confirmUpload/' + _this.uploadProcessId,
					[],
					).then(async function(response){
						if (response != null) {
							if (response.data != null) {
								_this.resetModal();
								_this.datas = Array();
								_this.fileupload = null;
								_this.isUploadSuccess = false;
							}
						}
						_this.isBusy = false;
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
			} else {
				if (this.fileupload != null) {
					let data = new FormData();
					data.append('file', this.fileupload);
					let _this = this;
					this.$http.post('partpurchasequalitycontrolconfirmation/upload',
						data,
						{ headers: { 'Content-Type': 'multipart/form-data' } }
					).then(async function(response){
						_this.uploadProcessId = response.data.id;
						_this.isUploadSuccess = true;
						await _this.getPartPurchaseQualityControlConfirmationForUpload();
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
				}
			}
		},
		getPartPurchaseQualityControlConfirmationForUpload : async function() {
			let _this = this;
			this.$http.get('partpurchasequalitycontrolconfirmation/uploadresult/' + _this.uploadProcessId)
				.then(async function(response) {
					_this.partPurchaseQualityControlConfirmations = [];
_this.partPurchaseQualityControlConfirmationDetails = [];


					if (response != null) {
						let result = response.data;
						_this.partPurchaseQualityControlConfirmations = result.filter(o => { return o.uploadValidationStatus == "Success"});
                        _this.totalSucceedPartPurchaseQualityControlConfirmation = _this.partPurchaseQualityControlConfirmations.length;

						_this.partPurchaseQualityControlConfirmationsFailed = result.filter(o => { return o.uploadValidationStatus != "Success"});
						_this.hasFailedDataPartPurchaseQualityControlConfirmation = true;
						_this.totalFailedPartPurchaseQualityControlConfirmation = 0;
						if(_this.partPurchaseQualityControlConfirmationsFailed == undefined || _this.partPurchaseQualityControlConfirmationsFailed.length === 0) _this.hasFailedDataPartPurchaseQualityControlConfirmation = false;
						if(_this.hasFailedDataPartPurchaseQualityControlConfirmation) _this.totalFailedPartPurchaseQualityControlConfirmation = _this.partPurchaseQualityControlConfirmationsFailed.length;
						_this.partPurchaseQualityControlConfirmationDetails = [];
						_this.partPurchaseQualityControlConfirmationDetailsFailed = [];
						_this.hasFailedDataPartPurchaseQualityControlConfirmationDetail = true;
						_this.totalSucceedPartPurchaseQualityControlConfirmationDetail = 0;
						result.forEach(function(element) {
							_this.partPurchaseQualityControlConfirmationDetails.push(...element.partPurchaseQualityControlConfirmationDetail.filter(o => { return o.uploadValidationStatus == "Success"}));
							_this.totalSucceedPartPurchaseQualityControlConfirmationDetail = _this.partPurchaseQualityControlConfirmationDetails.length;

							_this.partPurchaseQualityControlConfirmationDetailsFailed.push(...element.partPurchaseQualityControlConfirmationDetail.filter(o => { return o.uploadValidationStatus != "Success"}));
							if(_this.partPurchaseQualityControlConfirmationDetailsFailed == undefined || _this.partPurchaseQualityControlConfirmationDetailsFailed.length === 0) _this.hasFailedDataPartPurchaseQualityControlConfirmationDetail = false;
							if(_this.hasFailedDataPartPurchaseQualityControlConfirmationDetail) _this.totalFailedPartPurchaseQualityControlConfirmationDetail = _this.partPurchaseQualityControlConfirmationDetailsFailed.length;
						});
						_this.isBusy = false;
					}
				})
				.catch(error => {
					_this.$store.dispatch('addErrorMessageGlobal', error);
					_this.isBusy = false;
				});
		},
		downloadLog() {
			let _this = this;
			let url = 'partpurchasequalitycontrolconfirmation/downloadlog/' + _this.uploadProcessId;
			this.$http.get(url, {responseType: 'blob'}).then(async response => {
				if (response != null) {
					await saveAs(response.data, 'PartPurchaseQualityControlConfirmation.xlsx');
				}
			}).catch(error => {
				this.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
		}
	},
	beforeMount() {
	},
	mounted(){
	},
	watch: {
		fileupload(newValue, oldValue) {
			this.datas = Array();
			this.isUploadSuccess = false;
		}
	},
	computed: {
		okTitle: {
			get: function() {
				if (this.isUploadSuccess) {
					return "Process";
				}
				return "Upload";
				}
		},
		isShowPopup : {
			get: function () {
				if (this.openPopup) {
					this.filterPartPurchaseQualityControlConfirmation = new PartPurchaseQualityControlConfirmationFilter();
					return true;
				}
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
